import { useSearchParams, SetURLSearchParams } from 'react-router-dom';
import {
  RESET_CURRENT_RECIPES_PAGE,
  RESET_FILTERED_SORTED_RECIPES,
} from 'redux/modules/cms-hybrid-recipes-page/actions/types';
import { useWtrDispatch } from 'redux/hooks';

export default (): [URLSearchParams, SetURLSearchParams] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useWtrDispatch();

  const set: SetURLSearchParams = params => {
    setSearchParams(params);

    dispatch({
      type: RESET_CURRENT_RECIPES_PAGE,
    });

    dispatch({
      type: RESET_FILTERED_SORTED_RECIPES,
    });
  };
  return [searchParams, set];
};
